export default __webpack_public_path__ + "static/PaintingWithATwist-2d5890f39d21d52a773263a0c8d16ca6.png";